import styled, { useTheme } from 'styled-components';
import css from '@styled-system/css';

import Cta from 'humanity/components/cta';
import CheckCircle from 'humanity/icons/checkCircle';
import Container from 'humanity/primitives/container';
import Flex from 'humanity/primitives/flex';
import Heading from 'humanity/primitives/heading';
import Section from 'humanity/primitives/section';
import Text from 'humanity/primitives/text';
import { ctaBannerProps } from 'humanity/sections/ctaBanner/ctaBanner.types';
import TextContainer from 'humanity/components/textContainer';
import Grid from 'humanity/primitives/grid';
import { getPaddingValues } from 'utils/getPaddingValues';
import Disclosures from 'humanity/components/disclosures';

const ValueProp = styled(Flex)(
  css({
    justifySelf: ['start', null, 'center'],
    gridColumn: ['2 / span 10', 'auto / span 6', 'auto / span 4'],
  })
);

const IconWrapper = styled(Flex)(
  css({
    justifyContent: 'center',
    flexShrink: 0,
    mt: '-1px',
  })
);

const CtaBanner = ({
  backgroundColor = 'white',
  alignment = 'center',
  topPadding = 96,
  bottomPadding = 96,
  heading,
  subheading = '',
  cta,
  valueProps = null,
  disclosures,
  ...props
}) => {
  const theme = useTheme();
  return (
    <Section
      pt={getPaddingValues(topPadding)}
      pb={getPaddingValues(bottomPadding)}
      bg={backgroundColor}
      {...props}
    >
      <Container>
        <TextContainer textAlign={alignment ?? 'center'}>
          <Heading
            as="h2"
            variant={['h3', null, null, 'h2']}
            dangerouslySetInnerHTML={{ __html: heading?.trim() }}
          />
          {!!subheading?.length && (
            <Text
              variant="body"
              mt={[2, null, null, 3]}
              dangerouslySetInnerHTML={{ __html: subheading.trim() }}
            />
          )}
          <Cta
            mt={6}
            btnSize="lg"
            btnVariant={cta?.variant}
            location="cta_banner"
            {...cta}
          />
        </TextContainer>
        {valueProps && (
          <Grid mt={6}>
            {valueProps.map((valueProp) => (
              <ValueProp key={valueProp}>
                <IconWrapper>
                  <CheckCircle size={18} color={theme.colors.blue100} />
                </IconWrapper>
                <Text
                  variant="bodySmall"
                  ml={1}
                  dangerouslySetInnerHTML={{ __html: valueProp?.trim() }}
                />
              </ValueProp>
            ))}
          </Grid>
        )}
        {disclosures && <Disclosures mt={6} disclosures={disclosures} />}
      </Container>
    </Section>
  );
};

CtaBanner.propTypes = {
  ...ctaBannerProps,
};

export default CtaBanner;
